import { SuppressionsIcon } from "@minket/brand/icons/suppressions";
import { createFileRoute } from "@tanstack/react-router";
import { GhostTable } from "@/components/page/ghost";
import { Page } from "@/components/page/page";
import { ProjectScope } from "@/components/page/scope";
import { GatedAction } from "@/components/sending/available";
import { SuppressAction } from "@/components/sending/suppression-actions";
import { SuppressionLedger, suppressionColumns } from "@/components/sending/suppressions";

export const Route = createFileRoute("/suppressions")({
  component: Suppressions,
});

function Suppressions() {
  return (
    <Page
      title="Suppressions"
      description="Mail to these addresses is accepted and reported as suppressed, never delivered."
      action={
        <GatedAction
          list="suppressions"
          pending={{ label: "Suppress address", icon: SuppressionsIcon }}
          permission="suppressions.manage"
          forbidden="Viewers cannot suppress addresses"
        >
          {(projectId) => <SuppressAction projectId={projectId} />}
        </GatedAction>
      }
    >
      <ProjectScope
        will="Each suppressed address will be listed here with its reason and the mail it stops."
        icon={<SuppressionsIcon size={20} />}
        preview={(busy) => (
          <GhostTable columns={suppressionColumns} label="suppressions" busy={busy} />
        )}
      >
        {(project) => <SuppressionLedger projectId={project.id} />}
      </ProjectScope>
    </Page>
  );
}
